import { TokenPayload } from "../../../interfaces/hooks/useAuthInterfaces";
import { jwtDecode } from 'jwt-decode';

export const getExpTime = (token: string): number => {
    const decoded: TokenPayload = jwtDecode(token)
    return decoded.exp * 1000;
}